<template>
  <v-container id="forgotPassword">
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" lg="6" xl="4" class="py-0 mb-8">
        <v-row align="end">
          <ForgotPassword />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ForgotPassword from '@/views/forgotPassword/ForgotPassword'
export default {
  components: {
    ForgotPassword
  },
  computed: {
    bPoint() {
      return this.$vuetify.breakpoint
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
